export enum AnalyticsEvent {
  AVOIDED_CONSTRAINT = 'avoided_constraint',
  BUILT_PATH_SERVICE = 'built_path_service',
  BUILT_PATH = 'built_path',
  CLICKED_PATH = 'clicked_path',
  CLICKED_POINT = 'clicked_point',
  CLICKED_EDGE = 'clicked_edge',
  CLICKED_NODE = 'clicked_node',
  CREATED_SCENARIO = 'created_scenario',
  NAVIGATION = 'navigation',
  OPTIMIZED_SCENARIO = 'optimized_scenario',
  SAVED_PATH = 'saved_path',
  SAVED_SCENARIO = 'saved_scenario',
  SCENARIO_PATHS_ERROR = 'scenario_paths_error',
  SEARCHED_LOCATION = 'searched_location',
  USED_PATH_FINDER = 'used_path_finder',
  VIEWED_FLOW_HISTORY = 'viewed_flow_history',
  VIEWED_IOC_SEGMENT = 'viewed_ioc_segment',
  VIEWED_NOTICE_DETAILS = 'viewed_notice_details',
  VIEWED_NOTICE_HISTORY = 'viewed_notice_history',
  VIEWED_PRICE_HISTORY = 'viewed_price_history',
}
